import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Outlet, useLocation } from "react-router-dom";
import {
  changeCurrentMemberMenu,
  // screenChange
} from "../../store/screenSlice";
import FindMemberMenu from "../../components/FindMember/FindMemberMenu";
import InvoiceServices from "../../services/InvoiceServices";
import {
  updateMemberList,
  resetParameters,
} from "../../store/findMemberUpdatedApiSlice";
import RoundButtonWithIcon from "../../components/StyledComp/RoundButtonWithIcon";
import LeftArrowIcon from "../../Images/LeftArrowIcon";
import { assignCurrentMember } from "../../store/currentMemberSlice";
import { updateFM_MemberId } from "../../store/memberApiSlice";
import { screenConfig } from "../../config/screenConfig";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import AlertWithModal from "../../components/utilityComponents/AlertWithModal";
interface IPagination {
  TotalRecords: number;
  TotalAPIPages: number;
}
const Invoice: React.FC = () => {
  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  const dispatch = useDispatch();
  // dispatch(screenChange("Invoice"));
  const [refreshCount, setRefreshCount] = useState(0);
  const [memberList, setMemberList] = useState<any[]>([]);
  const [SortField, setSortField] = useState("Id");
  const [SortType, setSortType] = useState("Asc");
  const [CurrentAPICallPage, setCurrentAPICallPage] = useState(1);
  const [InvoicePerAPICall, setInvoicePerAPICall] = useState(10);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [TotalRecords, setTotalRecords] = useState(0);
  const [isAllSelected, setIsAllSelectd] = useState<boolean>(false);
  const [searchInput, setSearchInput] = useState<string>("");
  const [showInputs, setShowInputs] = useState<string>("");
  const [searchBox, setSearchBox] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  let startIndex = 0;
  let endIndex = 0 + InvoicePerAPICall;
  const location = useLocation();
  // const history = useHistory();
  const params = new URLSearchParams(location.search);
  const MemberId: string | null = params.get("MemberId");
  const decodedId = MemberId ? window.atob(MemberId) : null;
  console.log(MemberId, "MemberId#########");
  let invoiceListAPIParams = {
    CurrentPage: CurrentAPICallPage,
    SortType: SortType,
    SortBy: SortField,
    Paginate: InvoicePerAPICall,
    searchElement: searchInput,
    MemberId: decodedId,
  };

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  useEffect(() => {
    const fetchData = async () => {
      console.log("getInvoice called", refreshCount);
      const response = await InvoiceServices.getInvoice(invoiceListAPIParams);
      console.log("response...", refreshCount, ":", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success", refreshCount);
        setTotalRecords(response.data.data.Pagination[0].TotalRecords);
        setMemberList(response.data.data.Invoices);
      }
    };

    fetchData();
    return () => {
      console.log("Component unmounted");
    };
  }, [SortField, SortType, searchInput, CurrentAPICallPage, InvoicePerAPICall]);

  const handleChange = (value: number) => {
    setCurrentPage(value);
    setCurrentAPICallPage(value);
    console.log(value, CurrentAPICallPage, CurrentPage);
  };

  const handleSearchInputChange = (e: any) => {
    setShowInputs(e.target.value);
  };

  const handleSearchButtonClick = (e: any) => {
    setSearchInput(showInputs);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };
  const handleClearSearch = () => {
    setShowInputs("");
    setSearchInput("");
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };
  const handleSort = (newSortField: string) => {
    console.log("Handle sort called");
    setMemberList([]);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
    startIndex = 0;
    endIndex = 0 + InvoicePerAPICall;
    setSortType(
      newSortField === SortField
        ? SortType === "Desc"
          ? "Asc"
          : "Desc"
        : "Asc"
    );
    setSortField(newSortField);
  };
  const renderSortIcon = (field: string) => {
    if (field === SortField) {
      return SortType === "Desc" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M4 13h16l-8 8z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M12 3l8 8H4z" />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M12 3l8 8H4z" />
          <path d="M4 13h16l-8 8z" />
        </svg>
      );
    }
  };

  const rowUpdate = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    setInvoicePerAPICall(Number(event.target.value));
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };
  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-content-wrapper mt-2 pb-3">
        <div className="d-flex justify-content-between mb-3">
          <h1 className="page-heading mt-3">Invoice</h1>
          <form onSubmit={handleSearchButtonClick}>
            <div
              style={{
                display: "flex",
                position: "relative",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <input
                type="text"
                placeholder="Search"
                value={showInputs}
                onChange={handleSearchInputChange}
                style={{
                  padding: " 5px 0px 5px 40px",
                  backgroundColor: "rgb(250 250 250)",
                  border: "0px",
                  borderBottom: "1px solid #000",
                  width: "450px",
                }}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 29.999 30"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "1%",
                  transform: "translateY(-50%)",
                }}
              >
                <path
                  id="Path_410"
                  data-name="Path 410"
                  d="M97.348,125.943a4.922,4.922,0,0,0,1.211-1.028l7.662-7.662c.161-.161.264-.183.448-.037a11.212,11.212,0,0,0,5.24,2.3,11.863,11.863,0,1,0-5.534-20.866,11.78,11.78,0,0,0-3.75,5.439,11.86,11.86,0,0,0,1.864,10.958c.139.183.139.279-.029.448q-3.974,3.952-7.934,7.927a2.909,2.909,0,0,0-.756,1.005v.587a1.623,1.623,0,0,0,1,.939C96.959,125.943,97.157,125.943,97.348,125.943Zm16.558-8.749a9.369,9.369,0,1,1,9.343-9.409A9.372,9.372,0,0,1,113.906,117.194Z"
                  transform="translate(-95.77 -95.95)"
                  fill="currentColor"
                ></path>
              </svg>
              <button
                className="btn"
                type="submit"
                // onClick={handleSearchButtonClick}
                style={{
                  marginLeft: "8px",
                  background: "#366287",
                  color: "#FFFFFF",
                }}
              >
                Search
              </button>
              <button
                className="btn"
                onClick={handleClearSearch}
                style={{
                  marginLeft: "8px",
                  background: "#757575",
                  color: "#FFFFFF",
                }}
              >
                Clear
              </button>
            </div>
          </form>
          <div></div>
        </div>
        <div className="memberlist-table">
          <table>
            <thead>
              <tr>
                <th onClick={() => handleSort("InvoiceNumber")}>
                  Invoice ID{renderSortIcon("InvoiceNumber")}
                </th>
                <th onClick={() => handleSort("InvoiceDate")}>
                  Invoice Date{renderSortIcon("InvoiceDate")}
                </th>
                <th onClick={() => handleSort("InvoiceAmount")}>
                  Invoice Amount{renderSortIcon("InvoiceAmount")}
                </th>
                <th onClick={() => handleSort("FirstName")}>
                  First Name {renderSortIcon("FirstName")}{" "}
                </th>
                <th onClick={() => handleSort("LastName")}>
                  Last Name{renderSortIcon("LastName")}
                </th>
                <th onClick={() => handleSort("BarId")}>
                  BarID{renderSortIcon("BarId")}
                </th>
                <th onClick={() => handleSort("MemberCode")}>
                  Member Code{renderSortIcon("MemberCode")}
                </th>
                <th onClick={() => handleSort("OrderId")}>
                  Order ID{renderSortIcon("OrderId")}
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {memberList.map((invoice: any) => (
                <tr key={invoice.id}>
                  <td>{invoice.InvoiceNumber}</td>
                  <td>
                    {invoice.InvoiceDate != null
                      ? (() => {
                          const formattedDate = dayjs(
                            invoice.InvoiceDate
                          ).format("MM-DD-YYYY");
                          console.log("Formatted Date:", formattedDate);
                          return formattedDate;
                        })()
                      : "--"}
                  </td>
                  <td>{invoice.InvoiceAmount}</td>
                  <td>{invoice.FirstName}</td>
                  <td>{invoice.LastName}</td>
                  <td>{invoice.BarId}</td>
                  <td>{invoice.MemberCode}</td>
                  <td>{invoice.OrderId}</td>
                  <td>
                    <a href={invoice.InvoiceUrl} target="_blank">
                      <svg width="16" height="16" viewBox="0 0 576 512" fill="currentColor">
                        <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z"/>
                      </svg>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div
        className="container mb-2"
        style={{ paddingTop: "10px", borderTop: "1px solid #ddd" }}
      >
        <div className="grid left"></div>
        <div className="grid center">
          {/* Pagenation-start */}
          <div
            className="horizontal-wrapper-centeraligned"
            style={{ marginTop: "10px" }}
          >
            <div
              className="round-button-div"
              style={{ width: "30px", height: "30px", marginRight: "10px" }}
            >
              <RoundButtonWithIcon
                icon={<LeftArrowIcon height={15} width={8} />}
                onClick={() => handleChange(CurrentPage - 1)}
                disabled={CurrentPage === 1}
              />
            </div>

            {memberList.length > 1 ? (
              <div className="heading_medium">
                {" "}
                <span style={{ fontWeight: "500" }}>
                  {1 + (CurrentPage - 1) * InvoicePerAPICall}{" "}
                </span>{" "}
                -{" "}
                <span style={{ fontWeight: "500" }}>
                  {memberList.length + (CurrentPage - 1) * InvoicePerAPICall}{" "}
                </span>
                of <span style={{ fontWeight: "500" }}>{TotalRecords} </span>{" "}
                Invoice
              </div>
            ) : (
              <div>
                <div className="heading_medium">
                  <span style={{ fontWeight: "500" }}>{TotalRecords} </span>{" "}
                  members
                </div>
              </div>
            )}
            <div
              style={{
                height: "30px",
                width: "30px",
                transform: "rotate(180deg)",
                marginLeft: "10px",
              }}
            >
              {" "}
              <RoundButtonWithIcon
                icon={<LeftArrowIcon height={15} width={8} />}
                onClick={() => handleChange(CurrentPage + 1)}
                disabled={
                  CurrentPage === Math.ceil(TotalRecords / InvoicePerAPICall)
                }
              />{" "}
            </div>
          </div>
          {/* Pagenation-end */}
        </div>
        <div className="grid right">
          <div className="w-100 mt-2">
            <select
              className="dropdown-control-large-insidetextfield"
              name="pagesize"
              style={{ border: "1px solid #ddd", height: "30px" }}
              onChange={(e) => {
                rowUpdate(e);
              }}
              value={InvoicePerAPICall}
            >
              <option value="10">10 rows</option>
              <option value="25">25 rows</option>
              <option value="50">50 rows</option>
              <option value="100">100 rows</option>
              <option value="150">150 rows</option>
              <option value="200">200 rows</option>
            </select>
          </div>
        </div>
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};
export default Invoice;
